export const create = {
  form: {
    quantity: 'Quantity',
    submit: 'Submit',
    requireQuantity: 'Please input quantity',
    invalidNumbers: 'Only numbers are allowed.',
  },
  pageHeader: {
    title: 'Add New Tank history',
    back: 'Back',
  },
}
